export const LOGIN_PATH = "/auth/login";
export const HOME_PATH = "/c/";
export const PERMISSION_DENIED = "/external/permission-denied";
